import { watch } from "vue";
import { debounce } from "lodash";

const init = async (el, editorBuild, { props, emit, cacheData }) => {
  // Initial data
  cacheData = props.modelValue;
  props.config.initialData = props.modelValue;

  // Init CKEditor
  const editor = await editorBuild.create(el, props.config);

  // Attach CKEditor instance
  el.CKEditor = editor;

  // Set initial disabled state
  editor.editorDisabled = props.disabled;

  const debounceSetData = debounce(() => {
    console.log("change");
    const data = editor.getData();
    cacheData = data;
    emit("update:modelValue", data);
    emit("input", data);
  }, 500);

  // Set on change event
  editor.model.document.on("change:data", debounceSetData);

  // Set on focus event
  editor.editing.view.document.on("focus", (evt) => {
    emit("focus", evt, editor);
  });

  // Set on blur event
  editor.editing.view.document.on("blur", (evt) => {
    emit("blur", evt, editor);
  });

  // Set on ready event
  emit("ready", editor);

  // Watch model change
  watch(props, () => {
    if (cacheData !== props.modelValue) {
      el.CKEditor.setData(props.modelValue);
      console.log("model changed");
    }
  });
};

export { init };
